<template>
  <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.5033 7.41502L11.0014 2.3166L8.49961 7.41502L2.88307 8.23584L6.94796 12.2209L5.99071 17.8341L11.0014 15.1847L16.0122 17.8341L15.0549 12.2209L19.1198 8.23584L13.5033 7.41502ZM7.44775 5.97195L1.49711 6.8416C0.678668 6.96121 0.351012 7.96613 0.941655 8.54517L5.25145 12.7703L4.23529 18.7291C4.09584 19.5467 4.9552 20.1689 5.68849 19.7812L11.0014 16.972L16.3144 19.7812C17.0477 20.1689 17.9071 19.5467 17.7676 18.7291L16.7514 12.7703L21.0612 8.54518C21.6519 7.96613 21.3242 6.96121 20.5058 6.8416L14.5551 5.97195L11.8992 0.559471C11.5331 -0.186491 10.4698 -0.18649 10.1037 0.559471L7.44775 5.97195Z"
      fill="#141414"
    />
  </svg>
</template>

<script>
export default {
  name: 'Star'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
